<template>
  <div class="agenda-config-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Agendas</span>
          </b-col>
          <b-col cols="12" md="6" v-if="canAdd">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <router-link tag="a" class="btn btn-primary btn-sm" to="/configurar-agenda/nova-agenda"><i class="far fa-dot-circle"></i> Adicionar Agenda</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-form-row>
          <b-col cols="12" md="4" v-for="agenda in agendas" :key="agenda.id">
            <router-link tag="div" :to="'/configurar-agenda/' + agenda.id" class="box-cj pointer">
              <div class="header">
                <p class="title"><i class="far fa-calendar-alt mr-2"></i>{{ agenda.name }}</p>
              </div>
              <div class="content">
                <p class="sub-title">Disponibilidade da agenda</p>
                <ul class="valid-between">
                  <li>
                    <span class="label">A partir de:</span>
                    <span class="date">{{ moment(agenda.start_date).format('dddd, DD/MM/YYYY')}}</span>
                  </li>
                  <li>
                    <span class="label">Até:</span>
                    <span class="date">{{ moment(agenda.end_date).format('dddd, DD/MM/YYYY')}}</span>
                  </li>
                </ul>

                <p class="sub-title">Dias de funcionamento da agenda</p>
                <ul class="days-of-week">
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 0)}">D</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 1)}">S</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 2)}">T</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 3)}">Q</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 4)}">Q</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 5)}">S</li>
                  <li :class="{ 'enabled': agenda.schedules.find(s => s.day_of_week == 6)}">S</li>
                </ul>
              </div>
            </router-link>
          </b-col>
        </b-form-row>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        agendas: []
      }
    },
    mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.api.getAgendas({}).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.agendas = res.data;

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Agendas', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as suas agendas! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Agendas', err.response);
      });
    },
    methods: {

    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .agenda-config-list {
    padding: 20px 0;
  }
</style>
